module.exports = __webpack_public_path__ + "static/media/ico-folder.636796bb.svg";